import { Skeleton, SkeletonText } from '@dev-spendesk/grapes';

export const BreakdownGaugeSkeleton = ({
  isCondensed = false,
  legendMatrix,
}: {
  isCondensed?: boolean;
  legendMatrix?: number[];
}) => {
  return (
    <div className="flex flex-col gap-16">
      <Skeleton width="100%" height={isCondensed ? '8px' : '16px'} />
      {legendMatrix && (
        <div className="flex flex-row justify-between gap-16">
          {[...Array(legendMatrix.length).keys()].map((key) => (
            <div key={`legend-block-skeleton-${key}`} className="flex-1">
              {[...Array(legendMatrix[key]).keys()].map((index) => (
                <SkeletonText
                  key={`legend-block-item-${key}-skeleton-${index}`}
                />
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
